import * as React from 'react';
import { SVGProps } from 'react';

const IconTestSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 1a1 1 0 1 0 0 2v4L4.482 9.428l6.534-.802L10 7V3a1 1 0 0 0 0-2H6zm5.601 8.562-7.8.957-1.654 2.645A1.2 1.2 0 0 0 3.165 15h9.67a1.2 1.2 0 0 0 1.017-1.836l-2.251-3.602z" />
  </svg>
);
export default IconTestSizeS;
